import { React, useEffect, useState } from "react";

import remove from "../../../../../Assets/img/icons/remove.png";

import { DeleteCardModule } from "../../../../../Modal/DeleteCard";
import OutsideClickHandler from "react-outside-click-handler";
import { CircularProgressBar } from "@tomik23/react-circular-progress-bar";
import { Slider } from "antd";
import double_arrow from "../../../../../Assets/img/icons/double-arrow.png";
import chart from "../../../../../Assets/img/icons/chart__icon.svg";
import styles from "./stakingRisk_trash.module.css";
import { formatStakingCurrency } from "../../../../../Utils/helper";
export function StakingRiskTrashComponent({
  element,
  restoreItem,
  deleteItem,
}) {
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [alertvalue, setAlertValue] = useState();
  // const renderColorClassName = (risk) => {
  //   if (risk <= 100 && risk >= 80) {
  //     return {
  //       className: "card__product__number card__product__green",
  //       borderColor: "#4DC7B5",
  //     };
  //   } else if (risk < 80 && risk >= 60) {
  //     return {
  //       className: "card__product__number card__product__yellow",
  //     };
  //   } else if (risk < 60) {
  //     return {
  //       className: "card__product__number card__product__red",
  //     };
  //   } else if (risk === null || 0) {
  //     return {
  //       className: "card__product__number card__product__white",
  //     };
  //   }
  // };

  // const renderBorderClassName = (risk) => {
  //   if (risk <= 100 && risk >= 80) {
  //     return {
  //       className: "card__risk__chart__min card__border__color__green",
  //     };
  //   } else if (risk <= 79 && risk >= 60) {
  //     return {
  //       className: "card__risk__chart__min card__border__color__yellow",
  //     };
  //   } else if (risk <= 59) {
  //     return {
  //       className: "card__risk__chart__min card__border__color__red",
  //     };
  //   } else if (risk === null || 0) {
  //     return {
  //       className: "card__risk__chart__min card__border__color__white",
  //     };
  //   }
  // };
  const [stakedAmountInput, setStakedAmountInput] = useState("");
  const safety_index =
    100 - element?.stakingRiskUserInfos?.stakingRisk?.weightedScore;
  const clampedSafetyIndex = Math.min(
    100,
    Math.max(0, Math.round(Math.abs(safety_index))),
  );

  const coldprops = {
    percent: Math.round(
      // element?.stakingRisk?.safetyIndex
      //   ? element?.stakingRisk?.safetyIndex:
      // clampedSafetyIndex
      safety_index,
    ), // is require
    colorSlice: "#4DC7B5",
    fontColor: "#4DC7B5",
    fontSize: "1.625em",
    fontWeight: 900,
    size: 112,
    boxShadow: "inset 0 3px 6px rgb(0 0 0 / 16%), 0 3px 6px rgb(0 0 0 / 16%)",
    unit: "",
    textPosition: "0.35em",
    animationOff: false,
    inverse: false,
    round: true,
    number: false,
  };

  const riskprops = {
    percent: Math.round(
      // element?.stakingRisk?.safetyIndex
      //   ? element?.stakingRisk?.safetyIndex:
      // clampedSafetyIndex
      safety_index,
    ), // is require
    colorSlice: "#EFB661",
    fontColor: "#EFB661",
    fontSize: "1.625em",
    fontWeight: 900,
    size: 112,
    boxShadow: "inset 0 3px 6px rgb(0 0 0 / 16%), 0 3px 6px rgb(0 0 0 / 16%)",
    unit: "",
    textPosition: "0.35em",
    animationOff: false,
    inverse: false,
    round: true,
    number: false,
  };

  const holdprops = {
    percent: Math.round(
      // element?.stakingRisk?.safetyIndex
      //   ? element?.stakingRisk?.safetyIndex:
      // clampedSafetyIndex
      safety_index,
    ), // is require
    colorSlice: "#F27281",
    fontColor: "#F27281",
    fontSize: "1.625em",
    fontWeight: 900,
    size: 112,
    boxShadow: "inset 0 3px 6px rgb(0 0 0 / 16%), 0 3px 6px rgb(0 0 0 / 16%)",
    unit: "",
    textPosition: "0.35em",
    animationOff: false,
    inverse: false,
    round: true,
    number: false,
  };

  const whiteprops = {
    percent: 0, // is require
    colorSlice: "#f0f0f3",
    fontColor: "#f0f0f3",
    fontSize: "1.625em",
    fontWeight: 900,
    size: 178,
    boxShadow: "inset 0 3px 6px rgb(0 0 0 / 16%), 0 3px 6px rgb(0 0 0 / 16%)",
    unit: "",
    textPosition: "0.35em",
    animationOff: false,
    inverse: false,
    round: true,
    number: false,
  };

  const renderClassName = (level) => {
    switch (level) {
      case "Low Risk":
      case "Low – Medium Risk":
        return {
          className: "card cold defi",
          color: "#4dc7b5",
          props: coldprops,
        };
      case "Medium Risk":
        return {
          className: "card hold defi",
          color: "#EFB661",
          props: riskprops,
        };
      case "High Risk":
      case "Medium – High Risk":
        return {
          className: "card risky defi",
          color: "#F27281",
          props: holdprops,
        };
      default:
        return {
          props: whiteprops,
          color: "#C4C4C4",
          className: "card empty defi",
        };
    }
  };

  useEffect(() => {
    // setUnstakingValue(+element.autoUnstacking);
    setAlertValue(+element?.stakingRiskUserInfos?.alert);
  }, [element]);
  useEffect(() => {
    if (element?.stakingRiskUserInfos.stakedAmount) {
      setStakedAmountInput(
        `${formatStakingCurrency(element?.stakingRiskUserInfos?.stakedAmount)}`,
      );
    } else {
      setStakedAmountInput("");
    }
  }, [element?.stakingRiskUserInfos.stakedAmount]);
  return (
    <>
      <div
        className={`${
          renderClassName(
            element?.stakingRiskUserInfos?.stakingRisk?.scoreLevel,
          )?.className || ""
        } trash`}
        style={{ background: "#F0F0F3" }}
      >
        <div className="card__header">
          <div className="row">
            <div className="chart__open__btn">
              <img src={chart} alt="" className="chart__opened__btn__icon" />
            </div>
            <h2 className="card__title" style={{ cursor: "pointer" }}>
              {element?.stakingRiskUserInfos?.stakingRisk?.name}
            </h2>
            <div
              className="close__card__content"
              onClick={() => {
                setOpenDeleteModal(!openDeleteModal);
              }}
            >
              <span className="card__close">
                <span></span>
                <span></span>
              </span>
            </div>
          </div>
        </div>
        <div className="card__price" style={{ justifyContent: "space-around" }}>
          <div style={{ marginLeft: "20px", position: "relative" }}>
            <input
              type="text"
              className="card__wallet__input"
              value={stakedAmountInput}
              style={{
                marginTop: "5px",
                padding: "0px 0px 0 15px",
                borderRadius: "6px",
                border: "navajowhite",
                width: "100%",
                background: "transparent",
                outline: "none",
                color: "#364048",
                fontWeight: "bold",
                textAlign: "right",
                fontSize: "13px",
                fontFamily: "Assistant",
              }}
            />
            <span
              style={{
                position: "absolute",
                padding: "0px 0px",
                top: "50%",
                left: "-20px",
                transform: "translateY(-50%)",
                color: "#889096",
                fontSize: "13px",
                fontWeight: "600",
                pointerEvents: "none",
                fontFamily: "Assistant",
              }}
            >
              Staked
            </span>
          </div>
        </div>

        <div
          className="card__product__wrapper"
          style={{ paddingTop: "5px", position: "relative" }}
        >
          <div className="card__product__row">
            <div className={` ${styles.staking_card_product_scroller}`}>
              {element?.stakingRiskUserInfos?.stakingRisk?.stakingRiskClassifications.map(
                (item, index) => (
                  <div
                    key={index}
                    className="card_product_scroller_item"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                      padding: "8px 0",
                      borderBottom: "1px solid #e0e0e0",
                    }}
                  >
                    <p
                      className={`${styles.staking_card_product_title} "card_product_scroller_item_title"}`}
                      title={item.name}
                    >
                      {item.name}
                    </p>
                    <p
                      className={`${styles.staking_card_product_level} "card_product_scroller_item_level"}`}
                      style={{
                        color: renderClassName(
                          item.riskScoreType === "manual"
                            ? item.manualScoreLevel
                            : item.automaticScoreLevel,
                        )?.color,
                      }}
                    >
                      {(item.riskScoreType === "manual"
                        ? item.manualScoreLevel
                        : item.automaticScoreLevel
                      )
                        ?.replace("Risk", "")
                        .trim()}
                    </p>
                  </div>
                ),
              )}
            </div>
            <div className={`${styles.double_arrow}`}>
              <img src={double_arrow} alt="Toggle" />
            </div>
          </div>
        </div>
        <div
          className="card__risk"
          style={{ marginTop: "5px", position: "relative" }}
        >
          <h3 className="card__risk__title">Safety Index</h3>
          <div className={"card__risk__alert"}>
            <p className="card__risk__alert__title">Alert</p>
            <p
              className={
                "card__risk__alert__number" +
                " " +
                (alertvalue === 0 || null
                  ? "card__risk__alert__not_number"
                  : "card__risk__alert__number")
              }
            >
              {alertvalue === null || 0 ? 0 : alertvalue}
            </p>
          </div>
          <div
            className={
              "card__risk__range active card__slider" +
              " " +
              (alertvalue === 0 || null
                ? "card__slider_not_value"
                : "card__risk__range active card__slider")
            }
          >
            <Slider
              min={0}
              max={100}
              value={alertvalue === null || 0 ? 0 : alertvalue}
              orientation="vertical"
              tooltip={true}
              step={1}
            />
          </div>

          <div className="card__risk__chart" style={{ marginTop: "5px" }}>
            <CircularProgressBar
              {...renderClassName(element?.stakingRisk?.scoreLevel)?.props}
            >
              <div className="card__round__shadow"></div>
              <div className="card__risk__chart__min__wrapper">
                <p
                  className="card__risk__chart__number"
                  style={{
                    color: renderClassName(element?.stakingRisk?.scoreLevel)
                      ?.color,
                  }}
                >
                  {Math.round(safety_index)}
                </p>
              </div>
            </CircularProgressBar>
          </div>

          <div
            className="card__risk__info"
            style={{ bottom: "-5px", left: "25px" }}
          >
            <i className="icon-info-icon"></i>
          </div>
        </div>
        <div
          className="trash__wallet"
          onClick={() => {
            restoreItem(element.id);
          }}
        >
          <img
            width="44"
            height="48"
            src={remove}
            alt=""
            className="trash__wallet__icon"
          />
        </div>
        <div className="trash__layer"></div>
      </div>
      <OutsideClickHandler
        onOutsideClick={(event) => {
          setOpenDeleteModal(false);
        }}
      >
        {openDeleteModal ? (
          <DeleteCardModule
            title="You are going to delete this product"
            text="This product will be deleted and you will not be able to restore it."
            element={element}
            deleteItem={() => {
              deleteItem(element.id);
              setOpenDeleteModal(false);
            }}
            cancel={() => {
              setOpenDeleteModal(false);
            }}
          />
        ) : (
          ""
        )}
      </OutsideClickHandler>
    </>
  );
}
